import {
  CLEAR_RECORDING_TO_PLAY,
  SET_RECORDING_TO_PLAY,
} from 'containers/Player/actions/recordings/constants';

export const setRecordingToPlay = (recording, cb) => {
  return dispatch => {
    const data = {
      type: SET_RECORDING_TO_PLAY,
      recording,
    };
    dispatch(data);
    cb();
  };
};

export const clearRecordingToPlay = () => {
  return {
    type: CLEAR_RECORDING_TO_PLAY,
  };
};
